<template>
  <div class="calico-tracker-empty">
    <h2 class="heading--xsmall">
      No BetaScores
    </h2>
    <p class="body--medium">
      Search for businesses to view their BetaScores.
      The BetaScores you view will appear in this section and will be
      available without counting towards usage for 30 days.
    </p>

    <div style="width: fit-content;">
      <button
        class="button-utility"
        @click="show = true"
      >
        <i class="bi bi-search" /> Find a business
      </button>
    </div>
    <SearchDialog
      v-if="show"
      @close="show = false"
    />
  </div>
</template>

<script>
import SearchDialog from "@/components/pattern/searchDialog/index.vue";
export default { 
  name: 'CalicoTrackerEmptyState', 
  components: { SearchDialog },
  props: {
    onSearch: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      isModalOpen: false,
      show: false
    }
  },
  methods: {
    handleSearch(searchQuery) {
      this.$router.push({ 
        path: "/search-results", 
        query: { 
          businessName: searchQuery.businessName, 
          state: searchQuery.state, 
          zip: searchQuery.zip 
        } 
      });
    }
  } 
};
</script>

<style scoped lang="scss">
.calico-tracker-empty {
  @include stack-space($space-large);
  justify-content: center;
  align-items: center;
  font-style: italic;
  padding-top: $space-large;
  color: $color-text-secondary;
  
  border-top-width: 2px;
  border-top-style: dashed;
  border-top-color: $color-neutral;

  border-image: repeating-linear-gradient(
    to right,
    $color-neutral 0,
    $color-neutral 2px,
    transparent 2px,
    transparent 6px
  ) 2;
}
</style>
